<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5456_102710)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.02582 0.854884C7.32534 0.686248 7.66328 0.597656 8.00701 0.597656C8.35075 0.597656 8.68868 0.686248 8.98821 0.854884C9.28773 1.02352 9.53874 1.26651 9.71701 1.5604L9.71893 1.56357L15.3656 10.9902L15.371 10.9994C15.5456 11.3019 15.638 11.6447 15.639 11.994C15.64 12.3432 15.5495 12.6866 15.3766 12.99C15.2036 13.2934 14.9543 13.5462 14.6533 13.7233C14.3523 13.9004 14.0102 13.9956 13.661 13.9994L13.6537 13.9995L2.35302 13.9995C2.00382 13.9956 1.66171 13.9004 1.36073 13.7233C1.05974 13.5462 0.810381 13.2934 0.637445 12.99C0.46451 12.6866 0.37403 12.3432 0.375008 11.994C0.375986 11.6447 0.468387 11.3019 0.643019 10.9994L0.648434 10.9902L6.297 1.56039C6.47528 1.2665 6.72629 1.02352 7.02582 0.854884ZM8.00701 1.93099C7.89243 1.93099 7.77979 1.96052 7.67995 2.01673C7.58056 2.07269 7.49719 2.15321 7.43782 2.25058L1.79547 11.67C1.73869 11.7699 1.70866 11.8828 1.70834 11.9977C1.70801 12.1141 1.73817 12.2286 1.79582 12.3297C1.85346 12.4308 1.93658 12.5151 2.03691 12.5741C2.13636 12.6327 2.24928 12.6644 2.36461 12.6662H13.6494C13.7647 12.6644 13.8777 12.6327 13.9771 12.5741C14.0774 12.5151 14.1606 12.4308 14.2182 12.3297C14.2759 12.2286 14.306 12.1141 14.3057 11.9977C14.3054 11.8828 14.2753 11.7699 14.2186 11.6701L8.57701 2.2519C8.57675 2.25146 8.57648 2.25102 8.57621 2.25058C8.51683 2.15321 8.43347 2.07269 8.33408 2.01673C8.23424 1.96052 8.12159 1.93099 8.00701 1.93099ZM8.00701 4.66615C8.3752 4.66615 8.67368 4.96463 8.67368 5.33282V7.99949C8.67368 8.36768 8.3752 8.66615 8.00701 8.66615C7.63882 8.66615 7.34035 8.36768 7.34035 7.99949V5.33282C7.34035 4.96463 7.63882 4.66615 8.00701 4.66615ZM7.34035 10.6662C7.34035 10.298 7.63882 9.99949 8.00701 9.99949H8.01368C8.38187 9.99949 8.68035 10.298 8.68035 10.6662C8.68035 11.0343 8.38187 11.3328 8.01368 11.3328H8.00701C7.63882 11.3328 7.34035 11.0343 7.34035 10.6662Z"
        fill="#E7423A"
      />
    </g>
    <defs>
      <clipPath id="clip0_5456_102710">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.0078125)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
